// extracted by mini-css-extract-plugin
export default {"message":"Message_message__EV4m3","success":"Message_success__MVVVX","error":"Message_error__5F6e+"};